export default __webpack_public_path__ + "static/media/mon_24.cbd75b94.png";